// Centralized site config sourced from env. NEVER hardcode.
// The API is served from the same origin as the frontend (Cloudflare Pages
// with Functions), so we always use a relative "/api" path. This makes
// requests immune to a missing REACT_APP_BACKEND_URL at build time and
// keeps working across preview, production, and local docker-compose.
export const API = "/api";

export const APP_STORE_URL = process.env.REACT_APP_APP_STORE_URL;
export const PLAY_STORE_URL = process.env.REACT_APP_PLAY_STORE_URL;
export const GA4_ID = process.env.REACT_APP_GA4_ID;

export const BRAND = {
  name: "YeboNadi",
  parent: "Simple Concepts LLC",
  tagline: "Proof that still stands when the story changes.",
  address: "2820 S Alma School Rd, Suite 18, PMB 2034, Chandler, AZ 85286",
  email: "info@concepts-simplified.com",
  phone: "+1 (832) 423-1808",
  youtube: "https://www.youtube.com/channel/UChVXTlcq0PpmENNSjeia-Fw",
  legalDisclaimer:
    "You are responsible for complying with recording-consent laws in your state or jurisdiction. Whether a recording is admissible depends on applicable law.",
  logoUrl:
    "/logo.png",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Falsely accused", to: "/accused" },
  { label: "If you go missing", to: "/missing" },
  { label: "Altercations", to: "/altercations" },
  { label: "Pricing", to: "/pricing" },
  { label: "Security", to: "/security" },
  { label: "FAQ", to: "/faq" },
];
